// extracted by mini-css-extract-plugin
export default {"headline":"headline___3Ru_j","search":"search___3uKbw"};